import { createReducer } from 'react-principal';

const UPDATE_CURRENT_PAGE = Symbol();
const UPDATE_FILTERS = Symbol();
const DROPDOWN = Symbol();
const ID = Symbol();
const SHOW_MODAL = Symbol();
const ADVANCE_FILTER = Symbol();

const initialState = {
  currentPage: 1,
  filters: {
    name: '',
    creator: '',
  },
  dropdown: false,
  id: null,
  showModal: false,
  advanceFilter: {
    userName: '',
    nameAndFamily: '',
    mobileNumber:'',
  },
};

const reducer = createReducer({
  [UPDATE_CURRENT_PAGE]: (state, { payload: { currentPage } }) => ({
    ...state,
    currentPage,
  }),
  [UPDATE_FILTERS]: (state, { payload: { filters } }) => ({
    ...state,
    filters,
  }),
  [DROPDOWN]: (state, { payload: { Dropdown } }) => ({
    ...state,
    Dropdown,
  }),
  [ID]: (state, { payload: { id } }) => ({
    ...state,
    id,
  }),
  [SHOW_MODAL]: (state, { payload: { showModal } }) => ({
    ...state,
    showModal,
  }),
  [ADVANCE_FILTER]: (state, { payload: { advanceFilter } }) => ({
    ...state,
    advanceFilter,
    currentPage: 1,
  }),
});

function updateCurrentPage(currentPage: any) {
  return {
    type: UPDATE_CURRENT_PAGE,
    payload: { currentPage },
  };
}

function updateFilters(filters: any) {
  return {
    type: UPDATE_FILTERS,
    payload: { filters },
  };
}

function DropdownToggle(Dropdown: boolean) {
  return {
    type: DROPDOWN,
    payload: { Dropdown },
  };
}

function setId(id: any) {
  return {
    type: ID,
    payload: { id },
  };
}

function handleModal(showModal: boolean) {
  return {
    type: SHOW_MODAL,
    payload: { showModal },
  };
}

function handleFiltering(advanceFilter: any) {
  return {
    type: ADVANCE_FILTER,
    payload: { advanceFilter },
  };
}

export {
  initialState,
  reducer,
  updateCurrentPage,
  updateFilters,
  DropdownToggle,
  setId,
  handleModal,
  handleFiltering,
};
